
import * as React from 'react';
import { withCurrentItem, withCurrentItemSet, ISpecifiedItemProps } from '../decorators/selectors';
import { connectToItemCache } from '../decorators/connectToItemCache';
import { IItemCache } from '../../models/IItemCacheObserver';
import { ActionContextMenu, IActionContextMenuProps } from './ActionContextMenu';
import { itemsContextMenuControl } from '../../controls/itemsContextMenuControl';
import { ICommand } from '../../models/commands/ICommand';
import { newCommand } from '../commands/new/newCommand';
import { openCommand } from '../commands/open/openCommand';
import { uploadCommand } from '../commands/upload/uploadCommand';
import { shareCommand, copyLinkCommand } from '../commands/share/shareCommand';
import { downloadCommand } from '../commands/download/downloadCommand';
import { renameCommand } from '../commands/rename/renameCommand';
import { deleteCommand } from '../commands/delete/deleteCommand';
import { TelemetryProvider } from '../telemetry/TelemetryProvider';
import { wrapWithParent } from '../../utilities/components/Props';
import { IEventContext } from '@ms/telemetry-manager/lib/IEvent';
import { withDisplayName } from '../../utilities/components/Decorators';

const DEFAULT_COMMANDS = [
    newCommand,
    openCommand,
    uploadCommand,
    shareCommand,
    copyLinkCommand,
    downloadCommand,
    deleteCommand,
    renameCommand
];

const CONTEXT_MENU_TELEMETRY_CONTEXT: IEventContext = {
    component: 'ContextMenu'
};

export type IItemsContextMenuProps = IActionContextMenuProps;

/**
 * Component which provides a command bar with standard commands for the current item and
 * selected items.
 */
export const ItemsContextMenu: React.ComponentType<IItemsContextMenuProps> = withDisplayName('ItemsContextMenu')(wrapWithParent(
    withDisplayName('ItemsContextMenu.Telemetry')((props: Pick<React.Props<{}>, 'children'>) => {
        return (
            <TelemetryProvider
                withContext={ CONTEXT_MENU_TELEMETRY_CONTEXT }
            >
                { props.children }
            </TelemetryProvider>
        );
    }))(
        withCurrentItemSet()(
            connectToItemCache((itemCache: IItemCache, ownProps: ISpecifiedItemProps): {
                itemSetKey: string | undefined;
            } => {
                return {
                    itemSetKey: ownProps.itemKey
                };
            })(
                withCurrentItem()(
                    connectToItemCache(
                        (itemCache: IItemCache,
                            props: {
                                itemKey: string;
                                itemSetKey: string;
                                commands?: ICommand[];
                            }): Pick<IActionContextMenuProps, 'commands'> => {
                            const {
                                itemKey,
                                itemSetKey,
                                commands: moreCommands = []
                            } = props;
                            const controlHandler = itemCache.demandItemFacet(itemsContextMenuControl, itemKey);

                            const {
                                commands
                            } = itemsContextMenuControl.evaluate(controlHandler)(itemCache, {
                                itemKey: itemKey,
                                itemSetKey: itemSetKey,
                                commands: DEFAULT_COMMANDS
                            });

                            return {
                                commands: [...commands, ...moreCommands]
                            };
                        })(ActionContextMenu)
                )
            )
        )
    ));
